// extracted by mini-css-extract-plugin
export var container = "_7y-0";
export var error = "_7y-9";
export var label = "_7y-5";
export var light = "_7y-6";
export var md = "_7y-3";
export var sm = "_7y-2";
export var thin = "_7y-8";
export var thinBold = "_7y-7";
export var vertical = "_7y-4";
export var xs = "_7y-1";